export default [{
    title: "Almacén de documentos",
    fontIcon: "archive",
    resource: "Almacen Documentos",
    action: "ver-almacen-documentos",
    children: [{
        title: "Dashboard",
        icon: "LayoutIcon",
        resource: "Almacen Documentos",
        action: "ver-almacen-documentos-dashboard",
    }, {
        title: "Configuracion",
        icon: "SettingsIcon",
        resource: "Almacen Documentos",
        action: "ver-almacen-documentos-configuracion",
        children: [{
                route: "permisos-usuarios",
                title: "Permisos usuarios",
                resource: "Almacen Documentos",
                action: "ver-almacen-configuracion-permisos",
            },
            {
                route: "permisos-almacen",
                title: "Permisos almacen",
                resource: "Almacen Documentos",
                action: "ver-almacen-configuracion-permisos-almacen",
            },
        ]
    }, {
        title: "Mantenimiento",
        icon: "EditIcon",
        resource: "Almacen Documentos",
        action: "ver-almacen-documentos-mantenimiento",
        children: [{
            route: "mantenimiento-almacen",
            title: "Almacen",
            resource: "Almacen Documentos",
            action: "ver-almacen-mantenimiento-almacen",
        }]
    }, {
        title: "Transacciones",
        fontIcon: "exchange-alt",
        resource: "Almacen Documentos",
        action: "ver-almacen-documentos-transacciones",
        children: [{
            route: "almacen-documentos-buscar",
            title: "Buscador Documentos",
            resource: "Almacen Documentos",
            action: "ver-almacen-documentos-buscar-documento",
        }, {
            route: "gestion-archivos",
            title: "Gestion de archivos",
            resource: "Almacen Documentos",
            action: "ver-almacen-gestion-archivo",
        }]
    }, {
        title: "Informes",
        fontIcon: "file-prescription",
        resource: "Almacen Documentos",
        action: "ver-almacen-documentos-informes",
    }, ]
}, ]